import React, { useState, useContext, useEffect } from "react";
import styles from "./styles/PosSearchSettlement.module.css";
import DataContext from "../../../context/DataContext";
import { formatDateToLocalDate } from "../../../utils/utils";
import { calculateValues } from "../../../utils/utils";
import POSDataContext from "../../../context/POSDataContext";
import ButtonExpand from "../button_expand/ButtonExpand";
import { t } from "i18next";
import Instalment from "../instalment/Instalment";
import { ReactComponent as Pointer } from "../../../assets/triangle.svg";
import InstalmentPos from "../instalment_pos/InstalmentPos";
import useNumberFormat from "../../../hooks/useNumberFormat";
import { ReactComponent as IconBill } from "../../../assets/bill-1.svg";

import { ReactComponent as IconClock } from "../../../assets/clock.svg";
import { ReactComponent as IconGavel } from "../../../assets/gavel.svg";

/**
 * SideTicket component
 */
const PosSearchSettlement = ({
    ticket,

    currency,
    searched,
    handleCheckFunction,
    clickedTicketPos,
    handleClickedTicket,

    setShowTicketInfo,
    isOnly,

    selectedSettlementsPos,
    setCurrenInstalmentPos,
    clickedInstalmentPos,
    handleClickedInstalment,
    handleCheckInstalment,
    showReset,
}) => {
    const {
        setCurrentTicketPos,
        setTicketTypePos,

        setSelectedInstalmentsPos,
        selectedInstalmentsPos,
        selectedTicketsPos,
        isInstallemtHoverPos,
        isAddHoverPos,
    } = useContext(POSDataContext);

    const [total, setTotal] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const [showInstalments, setShowInstalments] = useState(false);
    const formatNum = useNumberFormat();
    useEffect(() => {
        setSelectedItems(getSelectedItems());
    }, [selectedInstalmentsPos]);

    //reset the showiInstalments from outside
    useEffect(() => {
        setShowInstalments(false);
    }, [showReset]);

    const handleExpandFunction = () => {
        setShowInstalments((prev) => !prev);
    };

    const onClickHandle = (selectInstalment) => {
        setShowTicketInfo(true);
        setCurrentTicketPos(ticket);
        setTicketTypePos(1);

        handleClickedTicket(ticket?.caseNo);
        if (!selectInstalment) {
            setCurrenInstalmentPos(ticket?.settlementTransactionItems?.[0]);

            handleClickedInstalment(
                ticket?.settlementTransactionItems?.[0]?.id,
            );
        }
    };

    const calculateSettlementValue = () => {
        const value =
            selectedItems &&
            selectedItems.length &&
            selectedItems.reduce(
                (acc, item) => acc + parseFloat(item.netAmount),
                0,
            );
        return value || 0;
    };

    useEffect(() => {
        setTotal(calculateSettlementValue());
    }, [selectedItems]);

    const getMustPaidItems = () => {
        const filteredItems =
            ticket?.settlementTransactionItems.filter(
                (item) => item.status === 0 || item.status === 1,
            ) || [];

        return filteredItems;
    };

    const getSelectedItems = () => {
        const selectedArray = selectedInstalmentsPos.map((item) =>
            item.instalmentId.toString(),
        );
        return ticket?.settlementTransactionItems.filter((item) =>
            selectedArray.includes(item.id.toString()),
        );
    };

    const handleLocalCheck = (event) => {
        event.stopPropagation();
        handleCheckFunction(event);

        if (event.target.checked) {
            const mustPaid = getMustPaidItems();

            if (mustPaid.length) {
                mustPaid.forEach((item) =>
                    setSelectedInstalmentsPos((prev) => [
                        ...prev,
                        {
                            instalmentId: item?.id.toString(),
                            amount: item?.netAmount.toString(),
                            instalmentInfo: item?.txt.toString(),
                            instalmentDate: item?.dateAndTime.toString(),
                            instalmentTransactionID:
                                ticket?.transactionID.toString(),
                        },
                    ]),
                );
            } else {
                const firstInstalment = ticket?.settlementTransactionItems[0];

                setSelectedInstalmentsPos((prev) => [
                    ...prev,
                    {
                        instalmentId: firstInstalment?.id.toString(),
                        amount: firstInstalment?.netAmount.toString(),
                        instalmentInfo: firstInstalment?.txt.toString(),
                        instalmentDate: firstInstalment?.dateAndTime.toString(),
                        instalmentTransactionID:
                            ticket?.transactionID.toString(),
                    },
                ]);
            }
        } else {
            setSelectedInstalmentsPos((prev) =>
                prev.filter(
                    (trans) =>
                        !selectedItems.some(
                            (item) => trans.instalmentId === item.id.toString(),
                        ),
                ),
            );
        }
    };

    const getSettlementStatus = () => {
        const mustPaid = getMustPaidItems();
        const count = mustPaid?.length ? mustPaid?.length : 0;

        const firstInstalment = ticket?.settlementTransactionItems[0];

        let color = "";
        if (firstInstalment) {
            switch (firstInstalment?.status) {
                case 0:
                    color = "rgba(255, 0, 0 , .25)";
                    break;
                case 1:
                    color = "rgba(255, 220, 0 , .25)";
                    break;
                default:
                    color = "rgba(0, 0, 0, 0)";
            }
        }

        return {
            color: color,
            count: count !== 0 ? count : "",
        };
    };

    const currentStatus = getSettlementStatus();
    return (
        <>
            <div
                role="button"
                className={`${styles.main_ticket_container} 

          

            ${
                clickedTicketPos === ticket?.caseNo && styles.clicked
            }  flex-container`}
                onClick={() => onClickHandle()}
            >
                {searched && !isOnly && (
                    <>
                        <div
                            className={`${styles.input_expand_container} flex-container`}
                        >
                            <ButtonExpand
                                CurrentState={showInstalments}
                                onClickFunction={handleExpandFunction}
                                size={"small"}
                                dark={true}
                            />
                        </div>
                        <div
                            className={`${styles.divider} flex-container`}
                        ></div>
                    </>
                )}
                <div
                    className={`${styles.input_check_container} flex-container`}
                >
                    <input
                        className={`${styles.input_check_element}`}
                        type="checkbox"
                        name={ticket?.caseNo || ""}
                        id={ticket?.caseNo || ""}
                        value={total || 0}
                        onClick={handleLocalCheck}
                        readOnly
                    />
                    <Pointer
                        className={`${styles.input_check_highlight}  ${
                            (isAddHoverPos &&
                                !selectedInstalmentsPos.length &&
                                !selectedTicketsPos.length) ||
                            (isInstallemtHoverPos === ticket?.caseNo &&
                                !selectedSettlementsPos.includes(
                                    ticket?.caseNo,
                                ))
                                ? styles.arrowFadeIn
                                : styles.arrowFadeOut
                        } `}
                    />
                    <label
                        className={`${styles.input_check_label}`}
                        htmlFor={ticket?.caseNo}
                        aria-label={`Check input for ticket ${ticket?.caseNo}`}
                    ></label>
                </div>

                <div className={`${styles.info_container} v-flex-container`}>
                    <div
                        className={`${styles.ticket_info} ${styles.number_tag}`}
                    >
                        <span>
                            <IconGavel
                                className={`${styles.ticket_icon} icon-component`}
                            />
                        </span>
                        {ticket?.caseNo}
                    </div>
                    <div
                        className={`${styles.ticket_info} ${styles.ticket_hide_info} ${styles.date_tag}`}
                    >
                        <span>
                            <IconClock
                                className={`${styles.ticket_icon} icon-component`}
                            />
                        </span>
                        {formatDateToLocalDate(
                            ticket?.settlementTransactionItems?.[0]
                                ?.dateAndTime,
                        )}
                    </div>
                    <div
                        className={`${styles.ticket_info} ${styles.ticket_hide_info_2nd} ${styles.amount_tag}`}
                    >
                        <span>
                            <IconBill
                                className={`${styles.ticket_icon} icon-component`}
                            />
                        </span>
                        {`${currency}${formatNum(
                            total,
                        )} / ${currency}${formatNum(ticket?.remainingAmount)}`}
                    </div>
                </div>

                <div
                    className={`${styles.info_indicator}  ${
                        currentStatus?.count ? styles.info_indicator_shadow : ""
                    } flex-container`}
                    style={{
                        backgroundColor: currentStatus?.color,
                    }}
                >
                    <p className={` ${styles.info_count}`}>
                        {currentStatus?.count}
                    </p>
                </div>
            </div>

            {showInstalments && ticket.settlementTransactionItems?.length ? (
                <div
                    className={`${styles.instalments_container} v-flex-container`}
                >
                    {ticket?.settlementTransactionItems?.length &&
                    ticket?.settlementTransactionItems.filter(
                        (item) => item?.status === 0 || item?.status === 1,
                    ).length ? (
                        <h4 className={`${styles.instalments_header} `}>
                            {t(`mandatory instalments`)}:
                        </h4>
                    ) : (
                        <></>
                    )}
                    <div
                        className={`${styles.mandetory_container} v-flex-container`}
                    >
                        {ticket?.settlementTransactionItems?.length &&
                            ticket?.settlementTransactionItems.map(
                                (transaction) => {
                                    if (
                                        transaction?.status === 0 ||
                                        transaction?.status === 1
                                    )
                                        return (
                                            <InstalmentPos
                                                transactionID={
                                                    ticket?.transactionID
                                                }
                                                caseNo={ticket?.caseNo}
                                                key={transaction?.id}
                                                selectedSettlementsPos={
                                                    selectedSettlementsPos
                                                }
                                                selectedInstalmentsPos={
                                                    selectedInstalmentsPos
                                                }
                                                setCurrenInstalmentPos={
                                                    setCurrenInstalmentPos
                                                }
                                                clickedInstalmentPos={
                                                    clickedInstalmentPos
                                                }
                                                handleClickedInstalment={
                                                    handleClickedInstalment
                                                }
                                                instalment={transaction}
                                                searched={false}
                                                handleCheckFunction={
                                                    handleCheckInstalment
                                                }
                                                onClickHandleSettlement={
                                                    onClickHandle
                                                }
                                                currency={currency}
                                            />
                                        );
                                },
                            )}
                    </div>
                    {ticket?.settlementTransactionItems?.length &&
                    ticket?.settlementTransactionItems.filter(
                        (item) => item?.status === 2,
                    ).length ? (
                        <h4 className={`${styles.instalments_header} `}>
                            {t(`upcoming instalments`)}:
                        </h4>
                    ) : (
                        <></>
                    )}
                    <div
                        className={`${styles.upcoming_container} v-flex-container`}
                    >
                        {ticket?.settlementTransactionItems?.length &&
                            ticket?.settlementTransactionItems.map(
                                (transaction) => {
                                    if (transaction?.status === 2)
                                        return (
                                            <InstalmentPos
                                                transactionID={
                                                    ticket?.transactionID
                                                }
                                                caseNo={ticket?.caseNo}
                                                key={transaction?.id}
                                                selectedSettlementsPos={
                                                    selectedSettlementsPos
                                                }
                                                setCurrenInstalmentPos={
                                                    setCurrenInstalmentPos
                                                }
                                                clickedInstalmentPos={
                                                    clickedInstalmentPos
                                                }
                                                handleClickedInstalment={
                                                    handleClickedInstalment
                                                }
                                                instalment={transaction}
                                                searched={false}
                                                handleCheckFunction={
                                                    handleCheckInstalment
                                                }
                                                onClickHandleSettlement={
                                                    onClickHandle
                                                }
                                                currency={currency}
                                            />
                                        );
                                },
                            )}
                    </div>
                </div>
            ) : (
                <></>
            )}
        </>
    );
};

export default PosSearchSettlement;
